import { ITagResult } from '../types/IResponse';
import { TagRequest } from './TagRequest';

import { IAnalyticsExtConnectionId } from '../../../settings/types/ISiteSettingsForSiteAdmin';

export class DeleteAnalyticsExtConnectionSettingsRequest extends TagRequest<{}, ITagResult> {
  constructor(connectionId: IAnalyticsExtConnectionId) {
    super('analyticsextensions', 'deleteAnalyticsExtensionsConnection', connectionId);
  }
}

